import { connect } from 'react-redux';
import * as resumeActions from 'redux-modules/resume/actions.js';
import * as resumeSelectors from 'redux-modules/resume/selectors.js';
import * as uiStateSelectors from 'redux-modules/uiState/selectors.js';
import CompetenceProfile from './CompetenceProfile';

function mapStateToProps(state) {
  return {
    competenceProfile: resumeSelectors.selectCompetenceProfile(state),
    language: uiStateSelectors.selectResumeLanguage(state),
    syncErrors: resumeSelectors.selectSyncError(state),
    syncing: resumeSelectors.selectSyncState(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSave: (data, failCallback) => dispatch(resumeActions.saveCompetenceProfile(data, failCallback))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CompetenceProfile);
